import React from 'react';
import { Edit, SimpleForm, BooleanInput, TextInput } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'

export const CustomerEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <Grid item xs={12} sm={6} >
          <TextInput source="id" disabled/>
        </Grid>
        <Grid item xs={12} sm={6} >
          <TextInput source="name" />
        </Grid>
        <Grid item xs={12} sm={6} >
          <BooleanInput source="enabled" />
        </Grid>
      </Grid>
    </SimpleForm>
  </Edit>
);

export default CustomerEdit
